import EndpointCardBlock from './EndpointCardBlock';
import { EndpointCardBlockProps, EndpointCardBlockValueProps } from './types';

export type { EndpointCardBlockProps, EndpointCardBlockValueProps };
export default EndpointCardBlock;
